import React from "react";
import {compose} from "redux";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {
  Image, Linking, Platform, SafeAreaView, StyleSheet, Text, TextInput, View, CheckBox
} from "react-native";
import MyTheme from "../../Theme/Theme";
import LogoComplet, {BOLogoComplet} from "../Picto/LogoComplet";
import BoutonGenerale from "../Bouton/BoutonGenerale";
import {login, getAppConfigJsonValue} from "../../API/API";
import {signIn} from "../../Store/Reducers/AuthReducer";
import * as Crypto from "expo-crypto";

class ConnexionScreen extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            error : false,
            fill : false,
            loading: true,
            cgu_activated: false,
            cgu_checked: false,
            cgu_required_error: false,
        }
        this.login = "";
        this.password = "";
        this.error = false;
        this.fill=false;
        this._fillForm = this._fillForm.bind(this);
        this._connexion = this._connexion.bind(this);
        if( this.props.route.params && this.props.route.params.reset ){
            this._resetNavigation();
        }
    }

    componentDidMount() {
      getAppConfigJsonValue("cgu").then((cgu) => {
	this.setState({loading: false, cgu, cgu_activated: cgu.last_version_at !== null})
      })
    }

    _resetNavigation(){
        this.props.navigation.reset({
            index: 0,
            routes: [{ name: 'Connexion' }],
        });
    }
    _connexion() {
      if (!this.state.fill) return;

      if (this.state.cgu_activated && !this.state.cgu_checked) {
	this.setState({ cgu_required_error: true });
	return;
      }

      // no need to check for then: we will be redirected automatically
      this.props.dispatch(signIn(this.login, this.password)).catch(() => {
        this.setState({ error: true, cgu_required_error: false });
      });
    }

    _fillForm(){
        if(this.login.length>0 && this.password.length>0){
            this.setState({
                fill:true,
                error:false
            });

        }else{
            this.setState({
                fill:false,
                error:false
            });
        }
    }
    acceptCGU(style) {
      const {t, theme} = this.props;
      const { cgu_checked, cgu_required_error, cgu } = this.state;

      const setCGUChecked = (v) => {
        this.setState({cgu_checked: v})
      }

      return <View>
	<View style={{display: "flex", flexDirection: "row", marginTop: "30px"}}>
	  <CheckBox value={cgu_checked} onValueChange={setCGUChecked} />
	  <Text style={style.cguText}>{ cgu.label_fr}&nbsp;</Text>
	  <Text style={{color: 'blue'}}
	    onPress={() => Linking.openURL("/app_config/file/cgu/fr")}>
	    { t("Review the GCU") }
	  </Text>
	</View>

        { cgu_required_error &&
	  <Text style={[style.titleInput,style.error]}>
	  { t("You must agree to the GCU") }
	  </Text> }
      </View>
    }
    render() {
        const style = StyleSheet.create({
            droidSafeArea: {
                flex: 1,
                paddingTop: Platform.OS === 'android' ? 35 : 0,
                backgroundColor: this.props.theme.colors.tertiary.grey3.value
            },
            logo :{
                width:80,
                minHeight:100
            },
            logoContainer : {
                width:"100%",
                justifyContent:"center",
                alignItems:"center",
                flexDirection:"row",
                gap : 10,
                flex:1
            },
            formContainer:{
                flex:3,
                backgroundColor:this.props.theme.colors.primary.White.value,
                borderRadius: 20,
                borderBottomEndRadius:0,
                justifyContent:"flex-end"
            },
            mdpOublieContainer :{
                flex:1,
            },
            mdpOublie:{
                fontFamily : this.props.theme.fonts.text,
                color : this.props.theme.colors.tertiary.black8.value,
                textAlign:"center",
                flexDirection:"row",
                fontSize:12,
                display : this.state.fill && !this.state.error  ? "none": "flex"

            },
            form: {
                flex : this.state.fill && !this.state.error ? 5: 10,
                paddingHorizontal:30,
                marginTop:30,
                justifyContent:"space-between"
            },
            input : {
                borderBottomWidth : 2,
                borderBottomColor : this.props.theme.colors.primary.blue1.value,
                color : this.props.theme.colors.primary.blue1.value,
                fontSize:16,
                paddingBottom:15
            },
            titleInput:{
                fontSize:14,
                fontFamily : this.props.theme.fonts.text,
                marginTop:40,
                marginBottom:20,
                color : this.props.theme.colors.tertiary.black1.value
            },
	    cguText: {
                fontSize:12,
                fontFamily : this.props.theme.fonts.text,
                color : this.props.theme.colors.tertiary.black1.value,
		paddingLeft: 10
	    },
            error :{
                marginTop:0,
                marginBottom:0,
                color : this.props.theme.colors.primary.error.value,
                display: "flex",
            },
            boutonContainer :{
                width:"100%",
                alignItems:"center",
                display : (this.state.fill && !this.state.error) ? "flex": "none"
            },
            bouton : {
                //backgroundColor:"red"
                marginHorizontal:30,
                paddingVertical:18
            }
        });

        //https://www.altelis.com/wp-content/uploads/2020/11/nicolas.png
        return (
            <SafeAreaView style={style.droidSafeArea}>
                <View style={style.logoContainer}>
                    <LogoComplet style={style.logo}/>
                    <BOLogoComplet style={style.logo} />
                </View>
                <View style={style.formContainer}>
                    <View style={style.form}>
                        <View>
                            {this.state.error && <Text style={[style.titleInput,style.error]}>E-mail ou mot de passe incorrect</Text>}

                            <Text style={style.titleInput}>Adresse e-mail</Text>
                            <TextInput onSubmitEditing={(event) => this._fillForm()} onChangeText={(text)=>{this.login = text;this._fillForm()}}   textContentType={"emailAddress"} keyboardType={"email-address"} style={style.input} placeholder={"Saisissez votre adresse mail"} placeholderTextColor={this.props.theme.colors.primary.blue3.value} />

                            <Text style={style.titleInput}>Mot de passe</Text>
                            <TextInput onSubmitEditing={(event) => this._fillForm()} onChangeText={(text)=>{this.password = text;this._fillForm()}}  secureTextEntry={true} textContentType={"password"} autoCompleteType={"password"} style={style.input} placeholder={"Saisissez votre mot de passe"} placeholderTextColor={this.props.theme.colors.primary.blue3.value}/>

			    { this.state.cgu_activated && this.acceptCGU(style) }
                        </View>
                    </View>
                    <View style={style.mdpOublieContainer}>
                        <View style={style.boutonContainer}>
                            <BoutonGenerale onPress={this._connexion}  style={style.bouton}  title={"Se connecter"}  isActivate={true} size={"medium"} hasBorder={false}/>
                        </View>
                        <Text style={style.mdpOublie}>Mot de passe oublié ? Veuillez contacter Reticular par mail à l'adresse support@reticularproject.com</Text>
                    </View>
                </View>

            </SafeAreaView>
        );
    }
}


const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme,isSignOut : state.AuthReducer.isSignOut};
}


export default compose(connect(mapStateToProps),withTranslation())(ConnexionScreen);
